import { HttpMethod } from '@aibees/shared/definition';
import { useNotify } from '@aibees/shared/hooks';
import { useBaseMutation } from '@aibees/shared/http';
import { baseQueryClient } from '@aibees/shared/http/base-query-client';
import { useWorkspace } from '@aibees/shared/workspace';
import { HttpStatusCode } from 'axios';
import { random } from 'lodash-es';
import { EXPORT_SEARCH_API_PREFIX, MESSAGES } from '../constants';
import { notificationIconMap } from '../utils';
import { AddExportSearchRequestBody, AddExportSearchResponse } from './types';
import { useBrowseSearchExports } from './use-browse-search-exports';
import { useInvalidateCompanyAndPeopleQueries } from './use-invalidate-company-and-people-queries';

export function useAddExportMutation() {
  const workspace = useWorkspace()?.id;
  const notify = useNotify();
  const invalidateData = useInvalidateCompanyAndPeopleQueries();

  return useBaseMutation<AddExportSearchRequestBody, AddExportSearchResponse>(
    {
      url: EXPORT_SEARCH_API_PREFIX.replace(':wid', String(workspace)),
      method: HttpMethod.post,
    },
    {
      onSuccess: () => {
        invalidateData();
        baseQueryClient.invalidateQueries([useBrowseSearchExports.name]);
        // update the export requests filter options
        baseQueryClient.invalidateQueries({
          predicate: (query) => {
            const { queryKey } = query;
            return (
              (Array.isArray(queryKey) &&
                queryKey.includes('companies_exports_request_query')) ||
              queryKey.includes('people_exports_request_query')
            );
          },
        });
      },
      onError(error, request) {
        if (error.status === HttpStatusCode.Conflict)
          notify.warning(
            'Please Wait – Request in Progress!',
            MESSAGES.ACTION_CONFLICT,
            random(1, 101),
            {
              icon: notificationIconMap.EXPORT,
            }
          );
        else if (error.cause.code !== 402)
          notify.error(error.message ?? 'An error occured.');
      },
      doNotShowErrorNotification: true,
    }
  );
}
